// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"434":"74b1e695","745":"a6f07ee2","819":"e844adea"}[chunkId] + ".chunk.css";
};